import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { Error, Organization, Person } from '@/components/Icons'

import messages from './messages'

const ReadableAudienceType = ({ displayType, type }: any) => {
  switch (type) {
    case 'email':
    case 'guid': {
      return (
        <>
          <Person />
          <FormattedMessage {...messages.typeEmployee} />
        </>
      )
    }

    case 'error': {
      return (
        <>
          <Error style={{ height: 16, width: 16 }} />
          {displayType}
        </>
      )
    }

    case 'group': {
      return (
        <>
          <Organization />
          <FormattedMessage {...messages.typeGroup} />
        </>
      )
    }

    default: {
      return (
        <>
          <Organization />
          {displayType}
        </>
      )
    }
  }
}

ReadableAudienceType.displayName = 'ReadableAudienceType'

ReadableAudienceType.propTypes = {
  displayType: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['email', 'error', 'filter', 'guid', 'group']).isRequired
}

export default ReadableAudienceType
